import { api } from '../index';
import { IDefaultSuccessResponse, TAxiosResponse } from '../baseApiTypes';
import { IContactUsForm, TNewsBlockResponse, TBlogPostResponse } from './types';

export const contactUs = (
  form: IContactUsForm,
): TAxiosResponse<IDefaultSuccessResponse> => api.post('/contact-us', form);

export const getNewsBlockData = (): TAxiosResponse<TNewsBlockResponse> =>
  api.get('/news-block');
  
export const getSingleNews = (slug:any): TAxiosResponse<TNewsBlockResponse> =>
  api.get(`/news/slug/${slug}`);
  
export const getAuthorNews = (slug:any): TAxiosResponse<TNewsBlockResponse> =>
    api.get(`/news/author/${slug}`);
	
export const getExpertise = (slug:any): TAxiosResponse<TNewsExpertise> =>
	api.get(`/news/expertise/${slug}`);
	
export const getSinglePosts = (slug:any): TAxiosResponse<TBlogPostResponse> =>
  api.get(`/blogpost/slug/${slug}`);
  
export const getSingleEventPosts = (slug:any): TAxiosResponse<TBlogPostResponse> =>
  api.get(`/eventpost/slug/${slug}`);

export const ContactUsApi = {
  contactUs,
  getNewsBlockData,
  getSingleNews,
  getAuthorNews,
  getExpertise,
  getSinglePosts,
  getSingleEventPosts
};

